import { Grid } from 'antd';
import { screenIsActive } from 'src/utils/helpers';
const { useBreakpoint } = Grid;

const useResponsive = () => {
  const screens = useBreakpoint();
  // Include MD (768-991px) as mobile/tablet
  const isMobileOrTablet =
    (screenIsActive(screens, 'xs') ||
     screenIsActive(screens, 'sm') ||
     screenIsActive(screens, 'md')) &&
    !screenIsActive(screens, 'lg') &&
    !screenIsActive(screens, 'xl') &&
    !screenIsActive(screens, 'xxl');

  return { isMobileOrTablet };
};

export default useResponsive;
